import type { PartnerConfig } from "@/content/partners/types"

export const AVANCO_PARTNER_SLUG = "avanco"

export const AVANCO_LOGO_PATH = "/partners/avanco/logo.png"

/** Azul da marca Avanço — só kicker/anel; CTAs ficam Action-Blue. */
export const avancoBrand = {
  accent: "#0056D6",
  accentDark: "#003FA3",
  accentLight: "#5B8FFF",
  navy: "#002a50",
  ringFrom: "#0056D6",
  ringTo: "#002a50",
  benefit: "#4ade80",
  benefitForeground: "#002a50",
} as const

export const avancoPartnerConfig: PartnerConfig = {
  slug: AVANCO_PARTNER_SLUG,
  name: "Avanço",
  fullName: "Avanço Informática",
  logoPath: AVANCO_LOGO_PATH,
  benefitMode: "percent_increment",
  benefitPercentIncrement: 5,
  isActive: true,
  metadata: {
    website: "https://avancoinfo.com.br/",
    industry: "software",
  },
}

export const avancoPartnerContent = {
  ...avancoPartnerConfig,
  tagline: "ERP e PDV em nuvem para o varejo de alimentos",
  websiteUrl: "https://avancoinfo.com.br/",
  benefitHeadline: "Benefício para colaboradores",
  heroHeadline: "Colaboradores da Avanço Informática têm desconto extra na energia",
  heroSubtitle:
    "Economize até 30% do total da sua conta de luz com a energia solar por assinatura da Astra.",
  partnershipIntro:
    "Colaboradores da Avanço Informática têm 5% a mais de desconto na energia por assinatura do que sem a parceria. Cadastro simples, benefício automático por este link.",
  partnershipTitle: "Avanço Informática e energia limpa, juntos",
} as const
